<span class="message-control-label label-visible" #messageLabel>
  @if (message.Payload.Radius) {
    <span>{{message.Payload.Radius}}km um </span>
    }{{message.Payload.Vicinity}}
  </span>

  <div class="map readonly" >
    <div #gmap></div>
  </div>